import { defineStore } from 'pinia'

export const useDBStore = defineStore('dbstore', {
  state: () => (
    {
      dbs: {},
    }),
  getters: {
  },
  actions: {
    setDB(dbName, db) {
      if (!this.dbs[dbName]) {
        this.dbs[dbName] = {};
      }

      this.dbs[dbName] = db;
    },
    getDB(dbName) {
      return this.dbs[dbName];
    },
    hasDB(dbName) {
      return this.dbs[dbName] !== undefined;
    }
  },
});
